export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-geo/src/constant.js
// module id = 285
// module chunks = 0 1 2 3 4